import { styled } from '@mui/material/styles';
import { TextField as RaTextField, TextFieldProps } from 'react-admin';

const StyledTextField = styled(RaTextField, { slot: 'Root' })(() => ({}));

function TextField({ variant = 'body1', ...props }: TextFieldProps): JSX.Element {
  // @ts-ignore
  return <StyledTextField {...props} variant={variant} />;
}

export { TextField };
export type { TextFieldProps };
